import React from 'react'
import Pt from 'prop-types'
import { connect } from 'react-redux'
import { push as pushPath } from 'react-router-redux'

import { SignupRecord } from 'internal-components/src/records'
import { makeSelectLoading } from 'internal-components/src/redux/modules/loading'

import PageLoading from '../../components/Layout/PageLoading'

/**
 * Implements workflow checking to ensure that the standard
 * signup workflow is followed.
 *
 * Redirects to the start of a signup form if there is no
 * signup present in the state or redirects to a finished
 * signup if the signup is finished.
 */
export class SignupWorkflow extends React.Component {
  componentWillMount() {
    if (!this.props.signup) {
      this.props.pushPath('/')
    }

    if (this.props.signup && this.props.signup.get('state') !== 'new') {
      this.props.pushPath(`/finished/${this.props.signup.get('reference')}`)
    }
  }

  render() {
    if (
      this.props.loading ||
      !this.props.signup ||
      this.props.signup.get('state') !== 'new'
    ) {
      return (
        <section className="container">
          <PageLoading />
        </section>
      )
    }

    return this.props.children
  }
}

SignupWorkflow.defaultProps = {
  loading: false,
}

SignupWorkflow.propTypes = {
  children: Pt.node.isRequired,
  loading: Pt.bool,
  pushPath: Pt.func.isRequired,
  signup: Pt.instanceOf(SignupRecord),
}

const mapStateToProps = () => {
  const selectLoading = makeSelectLoading()

  return state => ({
    loading: selectLoading(state, { type: ['products', 'offers'] }),
    signup: state.signupEdit.get('edit'),
  })
}

export default connect(
  mapStateToProps,
  {
    pushPath,
  },
)(SignupWorkflow)



// WEBPACK FOOTER //
// ./src/containers/Signup/Workflow.jsx